import { TOPICS_I18N_KEYS } from '../../../../features/topics/constants/i18n/Topicsi18nConstants';

export const TOPICS_I18N_EN =  {
  [TOPICS_I18N_KEYS.topics]:     "Topics",
  [TOPICS_I18N_KEYS.topic_name]: "Topic Name",
  [TOPICS_I18N_KEYS.description]: "Description",
  [TOPICS_I18N_KEYS.topic_keywords]: "Topic Keywords",
  [TOPICS_I18N_KEYS.categories]: "Categories",
  [TOPICS_I18N_KEYS.earliest_historical_data_date]: "Earliest Historical Data Date",
  [TOPICS_I18N_KEYS.status]: "Status",
  [TOPICS_I18N_KEYS.topic_successfully_created_within_48_hours_toast_msg]: "Topic has been successfully added. Data will be ready within 48 hours.",
  [TOPICS_I18N_KEYS.topic_successfully_created_within_estimated_time_toast_msg]: "Topic has been successfully added. Data will be ready within {{numberOfDays}} days {{numberOfHours}} hrs {{numberOfMinutes}} mins.",
  [TOPICS_I18N_KEYS.topic_successfully_updated_within_48_hours_toast_msg]: "Topic has been successfully updated. Data will be ready within 48 hours.",
  [TOPICS_I18N_KEYS.topic_successfully_updated_within_estimated_time_toast_msg]: "Topic has been successfully updated. Data will be ready within {{numberOfDays}} days {{numberOfHours}} hrs {{numberOfMinutes}} mins.",
  [TOPICS_I18N_KEYS.topic_successfully_edited_with_no_processed_needed_toast_msg]: "Topic has been successfully updated.",
  [TOPICS_I18N_KEYS.topic_successfully_deleted_toast_msg]: "Topic has been successfully deleted!",
  [TOPICS_I18N_KEYS.no_topic_keywords_string]: "-",
  [TOPICS_I18N_KEYS.topic_creation_failure_toast_msg]: "Failed to create topic.",
  [TOPICS_I18N_KEYS.file_successfully_submitted_toast_msg]: "File has been successfully submitted for processing.",
  [TOPICS_I18N_KEYS.file_submit_failed_toast_msg]: "Failed to submit file for processing.",
  [TOPICS_I18N_KEYS.retrieve_uploaded_files_failure_toast_msg]: "Failed to retrieve uploaded files for topic.",
  [TOPICS_I18N_KEYS.failed_to_delete_topic_msg]: "Failed to delete topic."
}



// WEBPACK FOOTER //
// ./src/locales/en/features/topics/topics.i18n.en.js